import userServices from './user' ;
import { LEGACY_BACKEND_URL } from '../config';

export const isAuthenticated = () => {
  return userServices.isLoggedIn();
};

export const login = async (email: string, password: string) => {
  // Assert email or password is not empty
  if (!(email.length > 0) || !(password.length > 0)) {
    throw new Error('Email or password was not provided');
  }
  const request = new Request(LEGACY_BACKEND_URL + "/user/signin", {
    method: 'POST',
    body: JSON.stringify({"email": email, "password": password}),
  });
  const res = await fetch(request);

  const data = await res.json();
  if ('token' in data["data"]) {
    userServices.logIn(data["data"]['token'], data["data"]['info']);
    localStorage.setItem('rootine_jwt', data['token']);
  } else if ('session_id' in data) {
    localStorage.setItem('session_id', data['session_id']);
    localStorage.setItem("email_login_code", data['email']);
    window.location.href = `/email-otp-login`;
  }
  return data;
};

export const logout = () => {
  userServices.logOut();
}